<div class="page-head">
  <div>
    <h1>Permissions</h1>
    <div class="sub">Every permission code roles can grant across the Plus platform</div>
  </div>
  <div class="head-actions">
    <ng-container *staffCan="'Platform.Roles.ManagePermissions'"><button type="button" class="act-ghost" (click)="toggleAddForm()">
      {{ showAddForm ? 'Cancel' : 'Add permission' }}
    </button></ng-container>
  </div>
</div>

<div class="page-body">
  @if (showAddForm) {
    <div class="panel form-panel">
      <div class="panel-title">Add permission</div>

      <ng-container *staffCan="'Platform.Roles.ManagePermissions'"><form (ngSubmit)="submit()" [formGroup]="form">
        <div class="form-grid">
          <label class="field">
            <span>Name</span>
            <input class="inp" type="text" formControlName="name" placeholder="e.g. CanViewReports" />
          </label>
          <label class="field">
            <span>Description</span>
            <input class="inp" type="text" formControlName="description" placeholder="Optional" />
          </label>
        </div>

        @if (message) {
          <div class="note note-ok">{{ message }}</div>
        }

        <div class="form-actions">
          <button type="submit" class="act">Add permission</button>
        </div>
      </form></ng-container>
    </div>
  }

  <div class="toolbar">
    <input
      class="inp"
      type="text"
      placeholder="Search code, name or description…"
      [(ngModel)]="searchTerm"
      (ngModelChange)="applyFilters()"
    />

    <select class="inp" [(ngModel)]="categoryFilter" (ngModelChange)="applyFilters()" aria-label="Filter by category">
      <option value="all">All categories</option>
      @for (category of categories; track category) {
        <option [value]="category">{{ category }}</option>
      }
    </select>

    <select class="inp" [(ngModel)]="statusFilter" (ngModelChange)="applyFilters()" aria-label="Filter by status">
      <option value="all">All statuses</option>
      <option value="active">Active only</option>
      <option value="inactive">Inactive only</option>
    </select>

    @if (hasFilters) {
      <button type="button" class="act-link" (click)="clearFilters()">Clear filters</button>
    }

    <span class="spacer"></span>

    <span class="muted count">
      {{ matchCount }} of {{ permissions.length }} permission{{ permissions.length === 1 ? '' : 's' }}
    </span>
    <button type="button" class="act-ghost act-sm" (click)="load()" [disabled]="isLoading">Refresh</button>
  </div>

  @if (isLoading) {
    <div class="loading">Loading permissions…</div>
  } @else if (loadError) {
    <div class="note note-err">{{ loadError }}</div>
  } @else if (!groups.length) {
    <div class="panel empty">
      {{ permissions.length ? 'No permissions match the current filters.' : 'No permissions have been defined yet.' }}
    </div>
  } @else {
    @for (group of groups; track group.category) {
      <div class="panel-flush">
        <div class="group-head">
          <span class="group-title">{{ group.category }}</span>
          <span class="pill pill-sm pill-grey">{{ group.permissions.length }}</span>
        </div>
        <div class="tbl-wrap flush">
          <table class="tbl">
            <thead>
              <tr>
                <th class="col-code">Code</th>
                <th class="col-name">Name</th>
                <th>Description</th>
                <th class="col-status">Status</th>
              </tr>
            </thead>
            <tbody>
              @for (permission of group.permissions; track permission.permissionId || permission.code) {
                <tr>
                  <td><code class="code">{{ permission.code }}</code></td>
                  <td>{{ permission.name }}</td>
                  <td class="muted">{{ permission.description || '—' }}</td>
                  <td class="col-status">
                    <span class="pill pill-sm" [class.pill-green]="permission.isActive !== false" [class.pill-grey]="permission.isActive === false">
                      {{ permission.isActive === false ? 'Inactive' : 'Active' }}
                    </span>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    }
  }
</div>
